export default __webpack_public_path__ + "static/S&Me_press_release-dc850e670e7353de065d18543f90bb2e.pdf";